import { memo } from 'react';
import { Drawer, Button, Select } from 'antd';
import FormItemWrapper from '~/components/common/FormItemWrapper/FormItemWrapper';
import { PlanetMosaicType } from '~/common/typescript/apis/RemoteImageAlertAPIs';

interface PlanetFilterPanelProps {
  visible: boolean;
  onClose: () => void;
  type: PlanetMosaicType;
  setType: (type: PlanetMosaicType) => void;
  year: number;
  setYear: (year: number) => void;
  month: number | null;
  setMonth: (month: number) => void;
  quarter: number;
  setQuarter: (quarter: number) => void;
  onSearch: () => void;
}

const PlanetFilterPanel: React.FC<PlanetFilterPanelProps> = ({
  visible,
  onClose,
  type,
  setType,
  year,
  setYear,
  month,
  setMonth,
  quarter,
  setQuarter,
  onSearch,
}) => {
  // Generate years for dropdown (from 2021 to current year)
  const years = Array.from({ length: new Date().getFullYear() - 2020 }, (_, i) => 2021 + i);

  return (
    <Drawer
      title="Tìm kiếm ảnh Planet"
      placement="right"
      closable={true}
      onClose={onClose}
      open={visible}
      width={375}
      style={{ position: 'absolute' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <FormItemWrapper label="Loại ảnh">
          <Select
            value={type}
            onChange={setType}
            style={{ width: '100%' }}
            options={[
              { value: PlanetMosaicType.NEWEST, label: 'Mới nhất' },
              { value: PlanetMosaicType.MONTHLY, label: 'Hàng tháng' },
              { value: PlanetMosaicType.QUARTERLY, label: 'Hàng quý' },
              { value: PlanetMosaicType.NORMALIZED, label: 'Đã chuẩn hoá' },
            ]}
          />
        </FormItemWrapper>

        <FormItemWrapper label="Năm">
          <Select
            value={year}
            onChange={setYear}
            style={{ width: '100%' }}
            options={years.map(y => ({ value: y, label: y.toString() }))}
          />
        </FormItemWrapper>

        {type === PlanetMosaicType.MONTHLY && (
          <FormItemWrapper label="Tháng">
            <Select
              value={month}
              onChange={setMonth}
              style={{ width: '100%' }}
              options={[
                { value: null, label: 'Tất cả' },
                ...Array.from({ length: 12 }, (_, i) => ({
                  value: i + 1,
                  label: `Tháng ${i + 1}`,
                })),
              ]}
            />
          </FormItemWrapper>
        )}

        {type === PlanetMosaicType.QUARTERLY && (
          <FormItemWrapper label="Quý">
            <Select
              value={quarter}
              onChange={setQuarter}
              style={{ width: '100%' }}
              options={[
                { value: 1, label: 'Quý 1' },
                { value: 2, label: 'Quý 2' },
                { value: 3, label: 'Quý 3' },
                { value: 4, label: 'Quý 4' },
              ]}
            />
          </FormItemWrapper>
        )}

        <Button type="primary" onClick={onSearch} style={{ width: '100%' }}>
          Tìm kiếm
        </Button>
      </div>
    </Drawer>
  );
};

export default memo(PlanetFilterPanel);
